import './tomsbars/style';
import FormStructure from './tomsbars/form_structure';

export default FormStructure;